import type { BaseKeyFunction, DisplayType } from "../../../../lib";

export type KeyMeRecentsProps = { displayType: DisplayType };

export const keyMeRecents: BaseKeyFunction<KeyMeRecentsProps> = ({
  displayType,
}) => ["me", "recents", { displayType }];
